// Download file or image on button click
import triggerEventClick from './tracking/trigger-event-click';

const fileDownload = (url, name, props) => {
  if (props.trackable) {
    const dataLayer = {
      pageContext: props.pageContext,
      event: props.eventAction,
      page: props.eventPage,
    };
    triggerEventClick(dataLayer);
  }

  const isBrowser = typeof window !== 'undefined'
  fetch(url)
    .then((resp) => resp.blob())
    .then((blob) => {
      const url = isBrowser ? window.URL.createObjectURL(blob) : null
      const a = document.createElement('a')
      const documentName = name
        .replace(/[' ']/g, '-')
        .replace(/[':']/g, '')
        .toLowerCase()
      a.style.display = 'none'
      a.href = url
      a.download = documentName.replace(/['---']/g, '-')
      document.body.appendChild(a)
      a.click()
      if (isBrowser) {
        window.URL.revokeObjectURL(url)
      }
    })
    .catch(() => {
      if (isBrowser) {
        window.open(url, '_blank') // fallback
      }
    })
}
export default fileDownload
